import TableHeightAuto from './table-height-auto';
import Vue from 'vue';

Vue.directive('table-height-auto',TableHeightAuto);